import { jsx as t } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import a from "./InputBase.js";
import { forwardRef as i } from "../../../external/preact/compat/dist/compat.module.js";
const m = i(function(e, r) {
  return /* @__PURE__ */ t(a, { classNameModifiers: e.classNameModifiers, ...e, ref: r, "aria-required": e.required, type: "text" });
});
export {
  m as default
};
